import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface IBackgroundIconProps extends IConDefaultType {}

function BackgroundIcon({ color, className, size = 40, rotate, flip }: IBackgroundIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_4996_189423)">
          <path
            d="M23 43C34.0457 43 43 34.0457 43 23C43 11.9543 34.0457 3 23 3C11.9543 3 3 11.9543 3 23C3 34.0457 11.9543 43 23 43Z"
            fill="black"
          />
        </g>
        <path
          d="M23 43C34.0457 43 43 34.0457 43 23C43 11.9543 34.0457 3 23 3C11.9543 3 3 11.9543 3 23C3 34.0457 11.9543 43 23 43Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.5 12C31.5376 12 34 14.4624 34 17.5V19L33.9933 19.1166C33.9355 19.614 33.5128 20 33 20C32.4872 20 32.0645 19.614 32.0067 19.1166L32 19V17.5L31.9948 17.308C31.8951 15.4643 30.3686 14 28.5 14H17.5L17.308 14.0052C15.4643 14.1049 14 15.6314 14 17.5V28.5L14.0052 28.692C14.1049 30.5357 15.6314 32 17.5 32H19L19.1166 32.0067C19.614 32.0645 20 32.4872 20 33C20 33.5523 19.5523 34 19 34H17.5C14.4624 34 12 31.5376 12 28.5V17.5C12 14.4624 14.4624 12 17.5 12H28.5ZM30 20C32.2091 20 34 21.7909 34 24V30C34 32.2091 32.2091 34 30 34H24C21.7909 34 20 32.2091 20 30V24C20 21.7909 21.7909 20 24 20H30ZM30 22H24C22.9456 22 22.0818 22.8159 22.0055 23.8507L22 24V30C22 31.0544 22.8159 31.9182 23.8507 31.9945L24 32H30C31.0544 32 31.9182 31.1841 31.9945 30.1493L32 30V24C32 22.9456 31.1841 22.0818 30.1493 22.0055L30 22ZM28.958 27.9531L29.0268 28.0246L30.7805 30.2053C30.8591 30.303 30.9019 30.4246 30.9019 30.55C30.9019 30.8234 30.7025 31.0502 30.4411 31.0928L30.3519 31.1H23.6733C23.5448 31.1 23.4203 31.055 23.3215 30.9727C23.1139 30.8 23.0658 30.5068 23.1941 30.2798L23.2506 30.1982L24.34 28.8891C24.3579 28.8676 24.3774 28.8475 24.3983 28.829C24.6005 28.6501 24.8976 28.647 25.1025 28.8083L25.1747 28.8765L25.9298 29.7299C25.9484 29.751 25.9687 29.7706 25.9904 29.7886C26.1981 29.9611 26.4952 29.9548 26.6949 29.7871L26.7649 29.7167L28.175 28.018C28.1986 27.9896 28.2249 27.9637 28.2536 27.9406C28.464 27.7714 28.7609 27.7823 28.958 27.9531Z"
          fill="#8A8A8A"
        />
        <defs>
          <filter
            id="filter0_d_4996_189423"
            x="0"
            y="0"
            width="46"
            height="46"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4996_189423" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4996_189423" result="shape" />
          </filter>
        </defs>
      </svg>
    </i>
  );
}

export default BackgroundIcon;
